export const CaseStatus = {
  OrderReceived: 'order_received',
  InProduction:  'in_production',
  Shipped:       'shipped',
  Delivered:     'delivered',
} as const;
export type CaseStatus = (typeof CaseStatus)[keyof typeof CaseStatus];

export const ALL_CASE_STATUSES: readonly CaseStatus[] = [
  CaseStatus.OrderReceived,
  CaseStatus.InProduction,
  CaseStatus.Shipped,
  CaseStatus.Delivered,
];

export const CASE_STATUS_LABELS: Readonly<Record<CaseStatus, string>> = {
  [CaseStatus.OrderReceived]: 'Order received',
  [CaseStatus.InProduction]:  'In production',
  [CaseStatus.Shipped]:       'Shipped',
  [CaseStatus.Delivered]:     'Delivered',
};

export interface LabCase {
  readonly id: string;
  readonly caseNumber: string;
  readonly patientName: string | null;
  readonly toothNumbers: string | null;
  readonly notes: string | null;
  readonly units: number;
  readonly deliveryDate: string | null;
  readonly status: CaseStatus | undefined;
}
